import {
  RESET_TRANSFER_CHAT,
  API_ERROR,
  GET_TRANSFER_CHAT,
  SET_TRANSFER_CHAT,
  TRANSFER_CHAT,
  TRANSFERED_CHAT,
} from "./actionTypes";

const initialState = {};

const TransferChat = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TRANSFER_CHAT:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload]: null,
        },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.action]: {
            error: {
              status: true,
              message: action.payload.message,
              body:  action?.payload?.body ?? null,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case GET_TRANSFER_CHAT:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state.status,
          get_transfer_chats: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SET_TRANSFER_CHAT:
      state = {
        transferable: action.payload.data,
        status: {
          ...state.status,
          get_transfer_chats: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    case TRANSFER_CHAT:
      state = {
        ...state,
        data: action.payload.data,
        status: {
          ...state.status,
          transfer_chat: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case TRANSFERED_CHAT:
      state = {
        ...state,
        data: [],
        status: {
          ...state.status,
          transfer_chat: {
            error: false,
            loading: false,
            success: {
              status: true,
              chatId: action.payload.chatId,
            },
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default TransferChat;
